import { useState, useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import axios from "axios";


const baseURL = `${process.env.REACT_APP_API_URL}`

export default function useAlbum() {
    const [loading, setLoading] = useState(true);
    const [selectedAlbum, setSelectedAlbum] = useState(null)
    const [albums, setAlbums] = useState([]);
    const [error, setError] = useState('')
    const { id } = useParams();


    const fetchAlbum = async (id) => {
        try {
            setLoading(true)
            const response = await axios.get(`${baseURL}/profiles/album_list/${id}/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
            });
            if (response.data.success) {
            setAlbums(response.data.albums)
            } else {
            setError('Error fetching album data')
            }
            setLoading(false)
            
        } catch(error) {
            setError('Error fetching album data')
            setLoading(false)
        }
    } 
    
    const fetchAlbumImages = async (albumId) => {
        if (!albumId) {
            setSelectedAlbum(null);
            return;
        }

        try {
            setLoading(true)
            const response = await axios.get(`${baseURL}/profiles/album_images/${albumId}/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
            });
            if ( response.data.success) {
            const album = response.data.album
            const images = response.data.images;
            setSelectedAlbum({...album, images});
            } else {
            setError('Error fetching album images')
            }
            setLoading(false)
        } catch(error) {
            setError('Error fetching album images data')
        }
    }

    useEffect(() => {
        if (id) {
            fetchAlbum(id);
        }
    }, [id]);

    return { albums, selectedAlbum,fetchAlbum, fetchAlbumImages, loading, error };
}